import request from '../request';

import { StatementAvailability } from './types';

type IGetPropertyStatementAvailability = (id: number) => Promise<StatementAvailability>;

export const getStatementAvailability: IGetPropertyStatementAvailability = async (id) => {
  const { data } = await request.get(`/financial/statement_availability/${id}/`);
  return data;
};
